import React from 'react';
import PropTypes from 'prop-types';
import {LocationShape} from '../../common/react/Shapes';

const Location = props => {
  const {
    location: {id, lat, lng, name, address, city, state, postalCode},
    onClick,
    selected
  } = props;

  const selectedClass = selected ? 'active' : '';

  return <div className={`location-for-map ${selectedClass}`} onClick={onClick}>
    <div className="name">{name}</div>
    <div className="address">{address}<br />{city}, {state}<br />{postalCode}</div>
    <div className="locationId">ID: {id}</div>
  </div>;
};

Location.propTypes = {
  location: LocationShape,
  onClick: PropTypes.func,
  selected: PropTypes.bool
};

export default Location;



/** WEBPACK FOOTER **
 ** ./src/main/js/contactMe/components/Location.js
 **/